import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex-grow bg-gray-100 rounded-lg mb-1 p-2 pt-1 overflow-y-auto" }
const _hoisted_2 = { class: "bg-white flex-grow rounded-r-lg py-3 px-1.5" }
const _hoisted_3 = { class: "text-sm mb-2 text-gray-600" }
const _hoisted_4 = { class: "text-xs text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCourses, (course) => {
      return (_openBlock(), _createElementBlock("div", {
        key: course.codeId,
        class: "mt-2 flex"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["rounded-l-lg w-4 flex-initial flex-shrink-0", [
          _ctx.hashColorClassNames(
            (course.codeId &&
              parseInt(
                course.codeId.slice(course.codeId.length - 6, course.codeId.length - 3),
                10,
              )) ||
              0
          ),
        ]])
        }, null, 2),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(course.name), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(course.codeId), 1)
        ])
      ]))
    }), 128))
  ]))
}